import React from "react";
import DynamicLayout from "../components/DynamicLayout";
import MoonPhaseExperience from "../components/tools/MoonPhaseExperience";
import '../assets/ascendant-display.sass';

const MoonPhasePage = () => {
    return (
        <DynamicLayout>
            <MoonPhaseExperience />
        </DynamicLayout>
    );
};

export default MoonPhasePage;
